import { Navigate, createBrowserRouter } from "react-router-dom";

import AppLayout from "./components/layout/AppLayout.tsx";
import RequireAuth from "./components/layout/RequireAuth.tsx";
import AuditPage from "./pages/AuditPage.tsx";
import CalendarPage from "./pages/CalendarPage.tsx";
import ClientsPage from "./pages/ClientsPage.tsx";
import CallDetailPage from "./pages/CallDetailPage.tsx";
import CallsPage from "./pages/CallsPage.tsx";
import DashboardPage from "./pages/DashboardPage.tsx";
import FeatureFlagsPage from "./pages/FeatureFlagsPage.tsx";
import GoogleAdsPage from "./pages/GoogleAdsPage.tsx";
import IntegrationsPage from "./pages/IntegrationsPage.tsx";
import JobDetailPage from "./pages/JobDetailPage.tsx";
import JobsPage from "./pages/JobsPage.tsx";
import LeadDetailPage from "./pages/LeadDetailPage.tsx";
import LeadsPage from "./pages/LeadsPage.tsx";
import LoginPage from "./pages/LoginPage.tsx";
import ServiceCatalogPage from "./pages/ServiceCatalogPage.tsx";
import SettingsPage from "./pages/SettingsPage.tsx";
import SetupPage from "./pages/SetupPage.tsx";
import SitesPage from "./pages/SitesPage.tsx";
import SmsPage from "./pages/SmsPage.tsx";
import SsoCallbackPage from "./pages/SsoCallbackPage.tsx";
import TechniciansPage from "./pages/TechniciansPage.tsx";
import TwilioAdminPage from "./pages/TwilioAdminPage.tsx";
import UsersPage from "./pages/UsersPage.tsx";

export const router = createBrowserRouter([
  { path: "/setup", element: <SetupPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/sso/callback", element: <SsoCallbackPage /> },
  {
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { path: "/", element: <Navigate to="/dashboard" replace /> },
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/leads", element: <LeadsPage /> },
      { path: "/leads/:id", element: <LeadDetailPage /> },
      { path: "/clients", element: <ClientsPage /> },
      { path: "/jobs", element: <JobsPage /> },
      { path: "/jobs/:id", element: <JobDetailPage /> },
      { path: "/calendar", element: <CalendarPage /> },
      { path: "/technicians", element: <TechniciansPage /> },
      { path: "/service-catalog", element: <ServiceCatalogPage /> },
      { path: "/calls", element: <CallsPage /> },
      { path: "/calls/:id", element: <CallDetailPage /> },
      { path: "/sms", element: <SmsPage /> },
      { path: "/sites", element: <SitesPage /> },
      { path: "/users", element: <UsersPage /> },
      { path: "/audit", element: <AuditPage /> },
      { path: "/integrations", element: <IntegrationsPage /> },
      { path: "/integrations/twilio", element: <TwilioAdminPage /> },
      { path: "/google-ads", element: <GoogleAdsPage /> },
      { path: "/feature-flags", element: <FeatureFlagsPage /> },
      { path: "/settings", element: <SettingsPage /> },
    ],
  },
]);
